const BASE_DELAY_MS = 500;
const MAX_DELAY_MS = 30_000;

/**
 * Exponential backoff with full jitter, capped at 30s — PLAN.md
 * "Heartbeats": "client reconnects with exponential backoff + jitter,
 * capped 30s." `random` is injectable so the schedule is deterministic in
 * tests.
 */
export function reconnectDelayMs(attempt: number, random: () => number = Math.random): number {
  const cap = Math.min(MAX_DELAY_MS, BASE_DELAY_MS * 2 ** attempt);
  return Math.floor(random() * cap);
}
